import { gql } from '@apollo/client';
import {
  PLAYER_INFO_FRAGMENT,
  PLAYER_SEASON_STAT_FRAGMENT,
} from '../../fragments';

export const GET_CURRENT_SEASON_STAT_DATA = gql`
  ${PLAYER_INFO_FRAGMENT}
  ${PLAYER_SEASON_STAT_FRAGMENT}
  query ($seasonId: Int) {
    teams(where: { seasonBySeason: { id: { _eq: $seasonId } } }) {
      id
      abbreviation
      name
      color
      colorSecondary
      rosters(where: { team: { seasonBySeason: { id: { _eq: $seasonId } } } }) {
        players {
          ...PlayerInfo
          ...PlayerSeasonStats
        }
      }
    }
  }
`;
